import { useState } from "react";

interface PropsType {
    addFileCallback: (files: File[]) => any,
    deleteFileCallback?: () => any
    accept?: string,
    multiple?: boolean,
    disabled?: boolean,
    uploadedFileInfo?: {
        fileKey: string
        fileOrgname: string
        fileUrl: string
    }
}

export default function FileUploadDragAndDrop({
    addFileCallback,
    deleteFileCallback,
    accept,
    multiple,
    disabled,
    uploadedFileInfo
}: PropsType) {
    const [dragOver, setDragOver] = useState<boolean>(false);

    const handleDragEnter = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);
    };

    const handleDragOver = (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = async (e: React.DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);

        if (e.dataTransfer) {
            const fileList = e.dataTransfer.files;

            if (fileList) {
                const files = Array.from(fileList);

                addFileCallback(files);
            }
        }
    };

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const { files: fileList } = e.target;

        if (fileList) {
            const files = Array.from(fileList);

            addFileCallback(files);
            e.target.value = "";
        }
    };

    return <>
        {/* TODO: 기능 구현 위해 적당히 UI를 구성하였으므로, 디자인 체크 필요함 */}
        <label className="w-100" htmlFor="file-upload"
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
            {!uploadedFileInfo
                ? <div className={`div_uploader ${dragOver ? "drag_over" : ""}`}>
                    {!disabled && <>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_file.png"} alt="" />
                        <div>
                            첨부할 파일을 끌어다 놓거나
                            <br />
                            <span>찾아보기</span>
                        </div>
                    </>}
                </div>
                :
                <div className="div_uploaded">
                    {dragOver && <div className="overlay"></div>}
                    {deleteFileCallback && <div
                        className="delete_btn"
                        onClick={e => {
                            e.stopPropagation()
                            e.preventDefault()
                            deleteFileCallback()
                        }}>
                        <img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"}
                            alt=""

                        />
                    </div>}
                    <img
                        className="uploaded_img"
                        src={process.env.REACT_APP_SERVER_URL + `api/file/images_download?${new URLSearchParams(uploadedFileInfo).toString()}`}

                        alt="" />
                </div>
            }
        </label>
        <input
            type={"file"}
            id={"file-upload"}
            className={"d-none"}
            onChange={handleChange}
            accept={accept}
            multiple={multiple}
            disabled={disabled}
        />
    </>
}